<template>
  <h4 class="text-center">Pesquisar tipos de equipamento</h4>

  <img
    src="@/assets/images/search.png"
    alt="search"
    class="d-none d-lg-block w-100 mb-5"
  />

  <div class="form-group row mb-1">
    <div class="col-lg-12 mb-1 mb-lg-0">
      <label>Tipo de equipamento</label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="machine_class_filters.name"
      />
    </div>
  </div>
  <div class="form-group row mb-1">
    <div class="col-lg-12 mb-1 mb-lg-0">
      <label>Id do tipo de equipamento</label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="machine_class_filters.id"
      />
    </div>
  </div>

  <div
    class="
      d-flex
      flex-column flex-lg-row
      align-items-center
      Isjustify-content-start
      justify-content-lg-between
    "
  >
    <button class="btn btn-success mb-3 mb-lg-0" @click="onFilter">
      <font-awesome-icon :icon="['fas', 'filter']"></font-awesome-icon>
      Filtrar
    </button>

    <button class="btn btn-secondary" @click="clearFilter">
      <font-awesome-icon :icon="['fas', 'broom']"></font-awesome-icon>
      Resetar
    </button>
  </div>
</template>

<script>
  import { onBeforeMount, onMounted, ref } from 'vue'
  import useMachineClass from '@/modules/MachineClass.js'

  export default {
    setup() {
      const loading = ref(true)

      const { machine_class_filters, listMachineClasses } = useMachineClass()

      const clearFilter = () => {
        machine_class_filters.value = {}
        refreshList()
      }

      const onFilter = () => {
        refreshList()
      }

      const refreshList = () => {
        listMachineClasses(1, 10)
      }

      onBeforeMount(() => {
        clearFilter()
      })

      onMounted(() => {
        listMachineClasses(1, 10).then(() => {
          loading.value = false
        })
      })

      return {
        machine_class_filters,
        onFilter,
        clearFilter,
      }
    },
  }
</script>
